<template>
    <base-dashboard-view class="edit-show settings">
        <transition name="fade" mode="out-in">
            <base-loader v-if="showsAreLoading" />
            <div v-else>
                <edit-show-header :show="show" />
                <transition name="fade" mode="out-in">
                    <player-embed-controler
                        v-slot:default="{
                                playerEmbed,
                                embedSettings,
                                methods,
                            }"
                    >
                        <router-view
                            :show="show"
                            :initialize-embed="methods.initializeEmbed"
                            :set-global-config="methods.setGlobalConfig"
                            :destroy-player="methods.destroyPlayer"
                            :player-embed="playerEmbed"
                            :embed-settings="embedSettings"
                            @set-embed-config="value => methods.setGlobalConfig(value)"
                            @set-embed-setting="value => methods.setEmbedSetting(value)"
                        />
                    </player-embed-controler>
                </transition>
            </div>
        </transition>
    </base-dashboard-view>
</template>

<script>
import { isObject } from 'lodash';
import { mapState } from 'vuex';
import EditShowHeader from '@/components/Shows/EditShowHeader';
import PlayerEmbedControler from '@/components/PlayerEmbedControler';

export default {
    components: {
        EditShowHeader,
        PlayerEmbedControler,
    },
    computed: {
        ...mapState(['shows']),

        /**
         * Indicates whether shows are loading.
         *
         * @returns {boolean} Shows loading status indicator.
         */
        showsAreLoading() {
            return ! isObject(this.shows);
        },

        /**
         * Get single show
         *
         * @returns  {object}  Single show object.
         */
        show() {
            return this.shows[this.$route.params.hash] || false;
        },
    },
};
</script>
